import { useState } from 'react';
import { Input, PasswordEyeInput } from '@/components/forms';
import { Button } from '@/components/ui';
import { LOGO, EXTERNAL_SUBMIT_PASSWORD } from '@/constants';
import styles from './GateModal.module.css';

export interface ExternalCreator {
  name: string;
  email: string;
  country: string;
}

interface GateModalProps {
  onUnlock: (creator: ExternalCreator) => void;
}

export function GateModal({ onUnlock }: GateModalProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!name.trim() || !email.trim() || !country.trim()) {
      setError('Please fill in all fields');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    if (!password) {
      setError('Password is required');
      return;
    }

    if (password !== EXTERNAL_SUBMIT_PASSWORD) {
      setError('Incorrect password');
      return;
    }

    onUnlock({ name: name.trim(), email: email.trim(), country: country.trim() });
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <img src={LOGO.src} alt={LOGO.alt} className={styles.logo} />
        <h1 className={styles.title}>Provider Registration</h1>
        <p className={styles.subtitle}>Please identify yourself before submitting a provider.</p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <Input
            name="gate-name"
            label="Your Name *"
            value={name}
            setValue={setName}
            placeholder="John Doe"
            isRequired
          />
          <Input
            name="gate-email"
            label="Your Email *"
            type="email"
            value={email}
            setValue={setEmail}
            placeholder="john@company.com"
            isRequired
          />
          <Input
            name="gate-country"
            label="Country *"
            value={country}
            setValue={setCountry}
            placeholder="Peru"
            isRequired
          />
          <PasswordEyeInput
            name="gate-password"
            label="Access Password *"
            value={password}
            setValue={setPassword}
            placeholder="Enter access password"
          />

          {error && <p className={styles.error}>{error}</p>}

          <Button variant="primary" size="md" type="submit">
            Continue
          </Button>
        </form>
      </div>
    </div>
  );
}
